import { Colors } from '../../models/enums'

export const typeIcon: { [key in Colors]?: string } = {
  [Colors.PRIMARY]: 'sms',
  [Colors.SUCCESS]: 'success',
  [Colors.WARNING]: 'warning',
  [Colors.DANGER]: 'error',
}
